import styles from './link.less'; export {styles};
import {MenuLinkData} from '../../../shared/menu';
import Links from '../links';

export interface LinkProps extends MenuLinkData {
    currentCategoryIds: string[];
    level: number;
}

export default class Link extends React.PureComponent<LinkProps, null> {

    isActive(): boolean {
        if (this.props.currentCategoryIds) {
            for (let id of this.props.currentCategoryIds) {
                if (this.props.id == +id) {
                    return true;
                }
            }
        }

        return false;
    }

    render() {
        return (
            <li className={classNames(styles.link, styles['level-' + this.props.level], {[styles.active]: this.isActive()}, {[styles.hasChildren]: this.props.children.length > 0})}>
                <a href={this.props.url} className={styles.name}>
                    {this.props.name}
                </a>
                {this.props.children.length > 0 && (
                    <Links
                        children={this.props.children}
                        currentCategoryIds={this.props.currentCategoryIds}
                        level={this.props.level + 1}
                    />
                )}
            </li>
        );
    }
}
